<template>
	<div>
		<transition name="modal">
			<div class="modal"
			     style="display: block">
				<div class="modal-dialog modal-lg"
				     role="document">

					<div class="modal-content">

						<div class="modal-header  abtg__header-modal">

							<h5 class="modal-title abtg__modal-title"
							    id="exampleModalLabel2">
								{{ $t('custom.label_modal_configure') }}</h5>

							<div class="tools">
								<div class="abtg__close-button">
									<a data-dismiss="modal"
									   @click="closeModal()">
										<i class="fas fa-times"></i>
									</a>
								</div>

							</div>

						</div>
						<div class="modal-body">

							<div class="modal-body">

								<!-- AGENZIA ACQUISTO -->
								<div class="row">
									<div class="col-12">
										<h5 class="abtg__readonly">
											<span v-show="estate_type === 1"
											      key="percentage">Percentuale</span>
											<span v-show="estate_type === 2"
											      key="fixed">Valore</span>
											Agenzia Acquisto
										</h5>
									</div>
								</div>
								<div class="d-flex">
									<div class="w-auto mr-3">

										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<vue-numeric class="mdl-textfield__input abtg__input"
											             currency=""
											             separator="."
											             decimalSeparator=","
											             :precision="2"
											             v-model="fixed_estate_1"
											             v-if="estate_type === 2"
											             key="fixed_1"></vue-numeric>

											<input class="mdl-textfield__input abtg__input"
											       name="percentage_estate_1"
											       type="text"
											       v-model="formData.percentage_estate_1"
											       v-money="money"
											       v-if="estate_type === 1"
											       key="percentage_1">

											<label class="mdl-textfield__label abtg__input-label">{{ $t('custom.label_percentage_estate_better_scenario') }}
											</label>

										</div>
									</div>
									<div class="w-auto mx-3">
										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<vue-numeric class="mdl-textfield__input abtg__input"
											             currency=""
											             separator="."
											             decimalSeparator=","
											             :precision="2"
											             v-model="fixed_estate_2"
											             v-if="estate_type === 2"
											             key="fixed_2"></vue-numeric>

											<input class="mdl-textfield__input abtg__input"
											       name="percentage_estate_2"
											       type="text"
											       v-model="formData.percentage_estate_2"
											       v-money="money"
											       v-if="estate_type === 1"
											       key="percentage_2">
											<label class="mdl-textfield__label abtg__input-label">{{ $t('custom.label_percentage_estate_middle_scenario') }}
											</label>

										</div>

									</div>
									<div class="w-auto mx-3">
										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<vue-numeric class="mdl-textfield__input abtg__input"
											             currency=""
											             separator="."
											             decimalSeparator=","
											             :precision="2"
											             v-model="fixed_estate_3"
											             v-if="estate_type === 2"
											             key="fixed_3"></vue-numeric>

											<input class="mdl-textfield__input abtg__input"
											       name="percentage_estate_3"
											       type="text"
											       v-model="formData.percentage_estate_3"
											       v-money="money"
											       v-if="estate_type === 1"
											       key="percentage_3">
											<label class="mdl-textfield__label abtg__input-label">{{ $t('custom.label_percentage_estate_worst_scenario') }}
											</label>

										</div>
									</div>

									<div class="w-auto mx-3">
										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<vue-numeric class="mdl-textfield__input abtg__input"
											             currency=""
											             separator="."
											             decimalSeparator=","
											             :precision="2"
											             v-model="fixed_estate_4"
											             v-if="estate_type === 2"
											             key="fixed_4"></vue-numeric>

											<input class="mdl-textfield__input abtg__input"
											       name="percentage_estate_4"
											       type="text"
											       v-model="formData.percentage_estate_4"
											       v-money="money"
											       v-if="estate_type === 1"
											       key="percentage_4">
											<label class="mdl-textfield__label abtg__input-label">{{ $t('custom.label_percentage_estate_consumptive') }}
											</label>

										</div>
									</div>

									<div class="w-auto mx-3">
										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width pt-2">
											<div class="form-check form-check-inline abtg__radio">
												<input class="form-check-input"
												       type="radio"
												       name="estateType"
												       id="inlineRadio12"
												       :value="1"
												       v-model="estate_type">
												<label class="form-check-label"
												       for="inlineRadio12">Percentuale</label>
											</div>
											<div class="form-check form-check-inline abtg__radio">
												<input class="form-check-input"
												       type="radio"
												       name="estateType"
												       id="inlineRadio21"
												       :value="2"
												       v-model="estate_type">
												<label class="form-check-label"
												       for="inlineRadio21">Valore fisso</label>
											</div>

										</div>
									</div>
								</div>

								<!-- AGENZIA VENDITA -->
								<div class="row" v-if="1==2">
									<div class="col-12">
										<h5 class="abtg__readonly">
											<span v-show="estate_sell_type === 1"
											      key="percentage">Percentuale</span>
											<span v-show="estate_sell_type === 2"
											      key="fixed">Valore</span>
											Agenzia Vendita
										</h5>
									</div>
								</div>
								<div class="d-flex" v-if="1==2">
									<div class="w-auto mr-3">

										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<vue-numeric class="mdl-textfield__input abtg__input"
											             currency=""
											             separator="."
											             decimalSeparator=","
											             :precision="2"
											             v-model="fixed_estate_sell_1"
											             v-if="estate_sell_type === 2"
											             key="fixed_1"></vue-numeric>

											<input class="mdl-textfield__input abtg__input"
											       name="percentage_estate_1"
											       type="text"
											       v-model="formData.percentage_estate_sell_1"
											       v-money="money"
											       v-if="estate_sell_type === 1"
											       key="percentage_1">

											<label class="mdl-textfield__label abtg__input-label">{{ $t('custom.label_percentage_estate_better_scenario') }}
											</label>

										</div>
									</div>
									<div class="w-auto mx-3">
										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<vue-numeric class="mdl-textfield__input abtg__input"
											             currency=""
											             separator="."
											             decimalSeparator=","
											             :precision="2"
											             v-model="fixed_estate_sell_2"
											             v-if="estate_sell_type === 2"
											             key="fixed_2"></vue-numeric>

											<input class="mdl-textfield__input abtg__input"
											       name="percentage_estate_2"
											       type="text"
											       v-model="formData.percentage_estate_sell_2"
											       v-money="money"
											       v-if="estate_sell_type === 1"
											       key="percentage_2">
											<label class="mdl-textfield__label abtg__input-label">{{ $t('custom.label_percentage_estate_middle_scenario') }}
											</label>

										</div>

									</div>
									<div class="w-auto mx-3">
										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<vue-numeric class="mdl-textfield__input abtg__input"
											             currency=""
											             separator="."
											             decimalSeparator=","
											             :precision="2"
											             v-model="fixed_estate_sell_3"
											             v-if="estate_sell_type === 2"
											             key="fixed_3"></vue-numeric>

											<input class="mdl-textfield__input abtg__input"
											       name="percentage_estate_3"
											       type="text"
											       v-model="formData.percentage_estate_sell_3"
											       v-money="money"
											       v-if="estate_sell_type === 1"
											       key="percentage_3">
											<label class="mdl-textfield__label abtg__input-label">{{ $t('custom.label_percentage_estate_worst_scenario') }}
											</label>

										</div>
									</div>
									<div class="w-auto mx-3">
										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<vue-numeric class="mdl-textfield__input abtg__input"
											             currency=""
											             separator="."
											             decimalSeparator=","
											             :precision="2"
											             v-model="fixed_estate_sell_4"
											             v-if="estate_sell_type === 2"
											             key="fixed_4"></vue-numeric>

											<input class="mdl-textfield__input abtg__input"
											       name="percentage_estate_4"
											       type="text"
											       v-model="formData.percentage_estate_sell_4"
											       v-money="money"
											       v-if="estate_sell_type === 1"
											       key="percentage_4">
											<label class="mdl-textfield__label abtg__input-label">{{ $t('custom.label_percentage_estate_consumptive') }}
											</label>

										</div>
									</div>

									<div class="w-auto mx-3">
										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width pt-2">
											<div class="form-check form-check-inline abtg__radio">
												<input class="form-check-input"
												       type="radio"
												       name="estateSellType"
												       id="inlineRadio13"
												       :value="1"
												       v-model="estate_sell_type">
												<label class="form-check-label"
												       for="inlineRadio13">Percentuale</label>
											</div>
											<div class="form-check form-check-inline abtg__radio">
												<input class="form-check-input"
												       type="radio"
												       name="estateSellType"
												       id="inlineRadio23"
												       :value="2"
												       v-model="estate_sell_type">
												<label class="form-check-label"
												       for="inlineRadio23">Valore fisso</label>
											</div>

										</div>
									</div>
								</div>

								<!-- IMPOSTA SOSTITUTIVA-->
								<div class="row">
									<div class="col-12">
										<h5 class="abtg__readonly">Percentuale Imposta Sostitutiva</h5>
									</div>
								</div>
								<div class="d-flex">
									<div class="w-auto mr-3">

										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<input class="mdl-textfield__input abtg__input"
											       name="percentage_estate_1"
											       type="text"
											       v-model="formData.substitutiveTax_1"
											       v-money="money">
											<label class="mdl-textfield__label abtg__input-label">{{ $t('custom.label_percentage_estate_better_scenario') }}
											</label>

										</div>
									</div>
									<div class="w-auto mx-3">
										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<input class="mdl-textfield__input abtg__input"
											       name="percentage_estate_2"
											       type="text"
											       v-model="formData.substitutiveTax_2"
											       v-money="money">
											<label class="mdl-textfield__label abtg__input-label">{{ $t('custom.label_percentage_estate_middle_scenario') }}
											</label>

										</div>

									</div>
									<div class="w-auto mx-3">
										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<input class="mdl-textfield__input abtg__input"
											       name="percentage_estate_3"
											       type="text"
											       v-model="formData.substitutiveTax_3"
											       v-money="money">
											<label class="mdl-textfield__label abtg__input-label">{{ $t('custom.label_percentage_estate_worst_scenario') }}
											</label>

										</div>
									</div>
									<div class="w-auto mx-3">
										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<input class="mdl-textfield__input abtg__input"
											       name="percentage_estate_4"
											       type="text"
											       v-model="formData.substitutiveTax_4"
											       v-money="money">
											<label class="mdl-textfield__label abtg__input-label">{{ $t('custom.label_percentage_estate_consumptive') }}
											</label>

										</div>
									</div>

								</div>

								<!-- TASSAZIONE 2a CASA-->
								<div class="row">
									<div class="col-12">
										<h5 class="abtg__readonly">Imposta sulla plusvalenza</h5>
									</div>
								</div>
								<div class="d-flex">
									<div class="w-auto mr-3">

										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<input class="mdl-textfield__input abtg__input"
											       name="percentage_estate_1"
											       type="text"
											       v-model="formData.percentage_tax_1"
											       v-money="money">
											<label class="mdl-textfield__label abtg__input-label">{{ $t('custom.label_percentage_estate_better_scenario') }}
											</label>

										</div>
									</div>
									<div class="w-auto mx-3">
										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<input class="mdl-textfield__input abtg__input"
											       name="percentage_estate_2"
											       type="text"
											       v-model="formData.percentage_tax_2"
											       v-money="money">
											<label class="mdl-textfield__label abtg__input-label">{{ $t('custom.label_percentage_estate_middle_scenario') }}
											</label>

										</div>

									</div>
									<div class="w-auto mx-3">
										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<input class="mdl-textfield__input abtg__input"
											       name="percentage_estate_3"
											       type="text"
											       v-model="formData.percentage_tax_3"
											       v-money="money">
											<label class="mdl-textfield__label abtg__input-label">{{ $t('custom.label_percentage_estate_worst_scenario') }}
											</label>

										</div>
									</div>
									<div class="w-auto mx-3">
										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<input class="mdl-textfield__input abtg__input"
											       name="percentage_estate_4"
											       type="text"
											       v-model="formData.percentage_tax_4"
											       v-money="money">
											<label class="mdl-textfield__label abtg__input-label">{{ $t('custom.label_percentage_estate_consumptive') }}
											</label>

										</div>
									</div>

								</div>

								<!-- RENDITA CATASTALE-->
								<div class="row">
									<div class="col-12">
										<h5 class="abtg__readonly">
											<span v-if="numero_casa != 3">Rendita catastale</span>
											<span v-if="numero_casa == 3">Tassa Registro</span>
										</h5>
									</div>
								</div>
								<div class="row">

									<div v-if="numero_casa != 3"
									     class="col-9">

										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<input class="mdl-textfield__input abtg__input"
											       @input="setRenditaValue($event.target.value)"
											       type="text"
											       v-model="formData.rendita_catastale_1"
											       v-money="money">
											<!--                      <label-->
											<!--                          class="mdl-textfield__label abtg__input-label">{{-->
											<!--                          $t('custom.label_percentage_estate_better_scenario')-->
											<!--                        }}</label>-->

										</div>
									</div>
									<div v-if="numero_casa != 3 && 1 == 2"
									     class="col-3">
										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<input class="mdl-textfield__input abtg__input"
											       type="text"
											       v-model="formData.rendita_catastale_2"
											       v-money="money">
											<label class="mdl-textfield__label abtg__input-label">{{ $t('custom.label_percentage_estate_middle_scenario') }}
											</label>

										</div>

									</div>
									<div v-if="numero_casa != 3 && 1 == 2"
									     class="col-3">

										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<input class="mdl-textfield__input abtg__input"
											       type="text"
											       v-model="formData.rendita_catastale_3"
											       v-money="money">
											<span v-if="numero_casa === 3">(Importo acquisto immobile * 9) / 100</span>
											<label class="mdl-textfield__label abtg__input-label">{{ $t('custom.label_percentage_estate_worst_scenario') }}
											</label>

										</div>
									</div>

									<div class="col-9"
									     v-if="numero_casa == 3">
										Imposta la percentuale da calcolare sull'importo d'acquisto
										<input class="mdl-textfield__input abtg__input"

													 type="text"
													 v-model="formData.percentuale_tassa_registro_1"
													 >
									</div>

									<div class="col-3">

										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
											<div class="form-check form-check-inline abtg__radio">
												<input class="form-check-input"
												       type="radio"
												       name="inlineRadioOptions"
												       id="inlineRadio0"
												       :value="3"
												       v-model="numero_casa">
												<label class="form-check-label"
												       for="inlineRadio0">Impresa</label>
											</div>
											<br clear="all" />
											<div class="form-check form-check-inline abtg__radio">
												<input class="form-check-input"
												       type="radio"
												       name="inlineRadioOptions"
												       id="inlineRadio1"
												       :value="1"
												       v-model="numero_casa">
												<label class="form-check-label"
												       for="inlineRadio1">1a casa</label>
											</div>
											<div class="form-check form-check-inline abtg__radio">
												<input class="form-check-input"
												       type="radio"
												       name="inlineRadioOptions"
												       id="inlineRadio2"
												       :value="2"
												       v-model="numero_casa">
												<label class="form-check-label"
												       for="inlineRadio2">2a casa</label>
											</div>

										</div>
									</div>

								</div>


                <div class="row">
                  <div
                      style="background-color: #efefef; padding:10px; margin-left:10px;"
                      class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                    <div class="form-check form-check-inline abtg__radio">
                      <input class="form-check-input"
                             type="checkbox"
                             v-model="cessione"
                             id="cessione">
                      <label class="form-check-label"
                             for="cessione">Cessione </label>
                    </div>


                  </div>
                </div>
							</div>

						</div>
						<div class="modal-footer">
							<button type="submit"
							        data-dismiss="modal"
							        @click="closeModal()"
							        class="btn btn-success abtg__default-button abtg__btn-star">

								SALVA E CHIUDI
							</button>
						</div>
					</div>

				</div>
			</div>

		</transition>
	</div>
</template>


<script>
	import { mixin } from '../../helpers/helper'
	import { Money } from 'v-money'
	import { createHelpers } from 'vuex-map-fields'
	import saveOk from '../commons/saveok'

	const { mapFields } = createHelpers({
		getterType: 'customfree/getField',
		mutationType: 'customfree/updateField',
	})

	export default {
		mixins: [mixin],
		components: { Money, saveOk },
		data: function() {
			return {
				money: {
					decimal: ',',
					thousands: '.',
					prefix: '',
					suffix: '',
					precision: 1,
					masked: false,
				},
				estate_type: 1,
				estate_sell_type: 1,
				percentage_estate_1: 0,
				fixed_estate_1: 0,
				fixed_estate_sell_1: 0,
				percentage_estate_2: 0,
				fixed_estate_2: 0,
				fixed_estate_sell_2: 0,
				percentage_estate_3: 0,
				percentage_estate_4: 0,
				fixed_estate_3: 0,
				fixed_estate_4: 0,
				fixed_estate_sell_3: 0,
				fixed_estate_sell_4: 0,
				numero_casa: 1,
        cessione: 0,
			}
		},

		computed: {
			...mapFields(['formData', 'inputs']),
		},
		mounted: function() {
			this.setLocalValues()
		},
		methods: {
			closeModal: function() {
				this.formData.estate_type = this.estate_type
				this.formData.estate_sell_type = this.estate_sell_type
				// this.formData.percentage_estate_1 = this.percentage_estate_1;
				this.formData.fixed_estate_1 = this.fixed_estate_1
				this.formData.fixed_estate_sell_1 = this.fixed_estate_sell_1
				//this.formData.percentage_estate_2 = this.percentage_estate_2;
				this.formData.fixed_estate_2 = this.fixed_estate_2
				this.formData.fixed_estate_sell_2 = this.fixed_estate_sell_2
				// this.formData.percentage_estate_3 = this.percentage_estate_3;
				this.formData.fixed_estate_3 = this.fixed_estate_3
				this.formData.fixed_estate_4 = this.fixed_estate_4
				this.formData.fixed_estate_sell_3 = this.fixed_estate_sell_3
				this.formData.fixed_estate_sell_4 = this.fixed_estate_sell_4
        this.formData.cessione = this.cessione
				// this.formData.numero_casa = this.numero_casa
				this.$store.commit('customfree/setData', {name: 'formData.numero_casa', data: 0 })
				this.$store.commit('customfree/setData', {name: 'formData.numero_casa', data: this.numero_casa })
				this.$emit('update', {
					estate_type: this.estate_type,
					numero_casa: this.numero_casa,
					estate_sell_type: this.estate_sell_type,
				})
				this.$parent.showHideModalConfigure()
				this.$store.commit('customfree/setData', {name: 'avoidRefresh', data: false })
			},

			setLocalValues: function() {
				this.numero_casa = this.formData.numero_casa
				this.estate_type = this.formData.estate_type
				this.estate_sell_type = this.formData.estate_sell_type
				// this.percentage_estate_1 = this.formData.percentage_estate_1;
				this.fixed_estate_1 = this.formData.fixed_estate_1
				this.fixed_estate_sell_1 = this.formData.fixed_estate_sell_1
				// this.percentage_estate_2 = this.formData.percentage_estate_2;
				this.fixed_estate_2 = this.formData.fixed_estate_2
				this.fixed_estate_sell_2 = this.formData.fixed_estate_sell_2
				// this.percentage_estate_3 = this.formData.percentage_estate_3;
				this.fixed_estate_3 = this.formData.fixed_estate_3
				this.fixed_estate_sell_3 = this.formData.fixed_estate_sell_3
				this.fixed_estate_4 = this.formData.fixed_estate_4
				this.fixed_estate_sell_4 = this.formData.fixed_estate_sell_4
        this.cessione = this.formData.cessione;
			},

			setRenditaValue(data) {
				this.formData.rendita_catastale_2 = data
				this.formData.rendita_catastale_3 = data
				this.formData.rendita_catastale_4 = data;
			},
		},
	}
</script>
